import classNames from 'classnames';

import { Campaign, Charity, Project } from '../../Shared/types';
import { ColorBadge } from '../../Shared/UI/ColorBadge';

export function CampaignLogo({
  campaign,
  charity,
  size = 'md',
}: {
  campaign: Campaign & {
    project: Project;
  };
  charity?: Charity;
  size?: 'md' | 'lg'
}) {
  const sizeClass = (size === 'md' && 'w-[32px]') || (size === 'lg' && 'w-[60px]');
  const aspectClass = (size === 'md' && 'aspect-square') || (size === 'lg' && 'aspect-video');
  const thumbnailUrl = campaign.thumbnail_url || campaign.project.thumbnail_url || charity?.thumbnail_url;

  if (thumbnailUrl) {
    return (
      <div className={classNames(sizeClass, aspectClass)}>
        <img src={thumbnailUrl} alt={campaign.title} className="block object-cover w-full h-full rounded" />
      </div>
    );
  }

  return (
    <ColorBadge
      name={campaign.title}
      color={charity?.brand_color || null}
      size={size}
      className={classNames(sizeClass, '!rounded')}
    />
  );
}
